import { PropsWithChildren } from 'react';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors, DragEndEvent } from '@dnd-kit/core';
import { restrictToVerticalAxis, restrictToWindowEdges } from '@dnd-kit/modifiers';

type DndQueuesSettingsContextProps = {
  handleDragEnd: (event: DragEndEvent) => void;
};

export const DndQueuesSettingsContext = ({
  handleDragEnd,
  children,
}: PropsWithChildren<DndQueuesSettingsContextProps>) => {
  const sensors = useSensors(useSensor(PointerSensor));

  return (
    <DndContext
      collisionDetection={closestCenter}
      modifiers={[restrictToVerticalAxis, restrictToWindowEdges]}
      sensors={sensors}
      onDragEnd={handleDragEnd}
    >
      {children}
    </DndContext>
  );
};
